var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_924_148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1711 11.0238C13.3688 11.0238 16.0252 13.3413 16.5523 16.3884C16.5657 16.4662 16.5782 16.5575 16.5895 16.6624C16.6345 17.0775 16.3345 17.4506 15.9193 17.4956C15.8922 17.4985 15.865 17.5 15.8378 17.5C15.3949 17.5 15.0205 17.1719 14.9623 16.7329C14.9478 16.6229 14.9317 16.5282 14.9142 16.4489C14.434 14.2717 12.4928 12.6429 10.1711 12.6429C7.85055 12.6429 5.91006 14.2702 5.42866 16.446C5.41097 16.526 5.39475 16.6216 5.38002 16.7328C5.32184 17.1719 4.94741 17.5 4.50446 17.5C4.0865 17.5 3.74768 17.1612 3.74768 16.7432C3.74768 16.7157 3.74918 16.6883 3.75213 16.661C3.76203 16.5703 3.77276 16.4906 3.7843 16.4217C4.2977 13.3583 6.96179 11.0238 10.1711 11.0238ZM10.1711 10.2143C7.48756 10.2143 5.31399 8.04071 5.31399 5.35714C5.31399 2.67357 7.48756 0.5 10.1711 0.5C12.8547 0.5 15.0283 2.67357 15.0283 5.35714C15.0283 8.04071 12.8547 10.2143 10.1711 10.2143ZM10.1711 8.59524C11.9602 8.59524 13.4092 7.14619 13.4092 5.35714C13.4092 3.5681 11.9602 2.11905 10.1711 2.11905C8.38208 2.11905 6.93303 3.5681 6.93303 5.35714C6.93303 7.14619 8.38208 8.59524 10.1711 8.59524Z",
    fill: "#306DA0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_924_148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.9524,
    height: 17,
    fill: "white",
    transform: "translate(3.69507 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.92bae7c83d36a95b68ea97a69cd54a51.svg";
export { ForwardRef as ReactComponent };